// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileMenu_mobile_menu__Ep\\+UV {
  display: none;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  background-color: #22272a;
  margin-bottom: 25px;
  border-radius: 10px;
}

/* Mobile */
@media (max-width: 767px) {
  .MobileMenu_mobile_menu__Ep\\+UV {
    display: flex;
  }
}

.MobileMenu_menu_item__V9WYj {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 0px;
  box-shadow: none;
  height: 80px;
  flex: 1 1;
  cursor: pointer;
  background-color: #22272a;
  color: white;

  /* Ensure equal width */
  width: 33.3%;

  .MobileMenu_menu_label__dkyW2 {
    color: white;
    font-weight: 500;
  }

  &:hover {
    background-color: #383c3f;
    font-weight: bold;

    .MobileMenu_menu_label__dkyW2 {
      font-weight: bold;
    }
  }
}

.MobileMenu_menu_item_left__v\\+GsM {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.MobileMenu_menu_item_right__rQG-h {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.MobileMenu_menu_icon__oIrUv {
  margin-bottom: 10px;
}

.MobileMenu_menu_label__dkyW2 {
  font-size: 12px;
  font-weight: bold;
  color: #383838;
}

.MobileMenu_selected_item__3ojlp {
  background-color: #383c3f;
  color: white;

  .MobileMenu_menu_label__dkyW2 {
    color: white;
    font-weight: bold;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/MobileMenu.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,SAAO;EACP,eAAe;EACf,yBAAyB;EACzB,YAAY;;EAEZ,uBAAuB;EACvB,YAAY;;EAEZ;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;;IAEjB;MACE,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;;EAEZ;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".mobile_menu {\n  display: none;\n  align-items: center;\n  justify-content: space-evenly;\n  width: 100%;\n  background-color: #22272a;\n  margin-bottom: 25px;\n  border-radius: 10px;\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .mobile_menu {\n    display: flex;\n  }\n}\n\n.menu_item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  border-radius: 0px;\n  box-shadow: none;\n  height: 80px;\n  flex: 1;\n  cursor: pointer;\n  background-color: #22272a;\n  color: white;\n\n  /* Ensure equal width */\n  width: 33.3%;\n\n  .menu_label {\n    color: white;\n    font-weight: 500;\n  }\n\n  &:hover {\n    background-color: #383c3f;\n    font-weight: bold;\n\n    .menu_label {\n      font-weight: bold;\n    }\n  }\n}\n\n.menu_item_left {\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n\n.menu_item_right {\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.menu_icon {\n  margin-bottom: 10px;\n}\n\n.menu_label {\n  font-size: 12px;\n  font-weight: bold;\n  color: #383838;\n}\n\n.selected_item {\n  background-color: #383c3f;\n  color: white;\n\n  .menu_label {\n    color: white;\n    font-weight: bold;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobile_menu": `MobileMenu_mobile_menu__Ep+UV`,
	"menu_item": `MobileMenu_menu_item__V9WYj`,
	"menu_label": `MobileMenu_menu_label__dkyW2`,
	"menu_item_left": `MobileMenu_menu_item_left__v+GsM`,
	"menu_item_right": `MobileMenu_menu_item_right__rQG-h`,
	"menu_icon": `MobileMenu_menu_icon__oIrUv`,
	"selected_item": `MobileMenu_selected_item__3ojlp`
};
export default ___CSS_LOADER_EXPORT___;
